export default "__VITE_ASSET__CTcHwYMo__";